let deadlines = [
  {
    title: "Tax Audit Report: Jan 15 '22",
    tooltip: "firms: gross receipt > ₹10Cr/professionals: > ₹50L",
  },
  {
    title: "Tax Dispute Settlement: Jan 31 '22",
    tooltip: "To be filed only in case of dispute",
  },
  {
    title: "No international transaction declaration: Jan 31, '22",
    tooltip: "for audited assesses only",
  },
  {
    title: "Transfer Pricing Certificate: Feb 15 '22",
    tooltip: "furnish audit reports",
  },
  {
    title: "ITR for Companies: Feb 15 '22",
    tooltip: "for firms under Sec 139(1)",
  },
  {
    title: "Completion of Penalty Proceedings: Mar 31 '22",
    tooltip: "applies to only penalty cases",
  },
];

export default deadlines;
